import { GET_CATEGORY_FILTERS_BY_ID } from 'ACTIONS';

export const getCategoryFiltersById = (category, payload, req) => ({
    type: GET_CATEGORY_FILTERS_BY_ID,
    payload,
    category,
    req
});
